// extracted by mini-css-extract-plugin
export default {"button":"ItemArrow_button__3VMnq","button_disabled":"ItemArrow_button_disabled__ptO2N","icon":"ItemArrow_icon__PdW+R"};